module.exports = __webpack_public_path__ + "static/media/2.0299ac7c.jpg";